//@ts-nocheck
import React, { ReactNode, useEffect, useState } from "react";

import { Button, Checkbox, Input, Modal, Spin, Switch, TextArea } from "../../../../BP2Components";
import { DndProvider } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import { DraggableContainer, DraggableObject } from "./DnDHandler";
import { FilterItem, updateJoinOperatorInFirstConditions } from "./TableFIlterScripts";
import DraggableObjectContent from "./DraggableObjectContent";
import { useTableListContext } from "../../../../../context/TableListContext/TableListContext";
import projectConfig from "@projectConfig";
import IntlMessages from "../../../../../util/IntlMessages";
import "../TableFilter/ConfirmModal/ConfirmModal.less";

interface TableFilterEditorProps {
   isOpen: boolean;
   setIsOpen: (val: boolean) => void;
   currentFilter: FilterItem | undefined;
   setCurrentFilter: (filter: FilterItem | undefined) => void;
   activeTab: number;
   handleSaveFilter: (filter: FilterItem) => Promise<void>;
   topBarTitle: ReactNode;
}

const TableFilterEditor: React.FC<TableFilterEditorProps> = ({
   isOpen,
   activeTab,
   setIsOpen,
   currentFilter,
   setCurrentFilter,
   handleSaveFilter,
   topBarTitle,
}) => {
   const [filterFromList, setFilterFromList] = useState();
   const { columnList, listFilters, editedListFilters } = useTableListContext();

   useEffect(() => {
      const filterFromList = updateJoinOperatorInFirstConditions(editedListFilters).find(
         (filter) => filter.id === currentFilter.id,
      );
      setFilterFromList(filterFromList);
   }, [editedListFilters]);
   const handleAddSection = (currentFilter) => {
      setFilterFromList((prev) =>
         prev?.id === currentFilter.id
            ? {
                 ...prev,
                 filterSections: [
                    ...prev.filterSections,
                    {
                       active: true,
                       joinOperator: "OR",
                       order: prev.filterSections.length,
                       conditions: [
                          {
                             active: true,
                             joinOperator: "OR",
                             operator: "EQUAL",
                             order: 0,
                             techName: "",
                             value: [],
                          },
                       ],
                    },
                 ],
              }
            : prev,
      );
   };

   const handleAddCondition = (currentFilterSection) => {
      setFilterFromList((prev) => {
         const updatedSections = prev?.filterSections.map((section) => {
            if (section.order === currentFilterSection.order) {
               const existingOrders = section.conditions.map((cond) => cond.order);

               const nextOrder = existingOrders.length ? Math.max(...existingOrders) + 1 : 0;

               const newCondition = {
                  active: true,
                  joinOperator: "OR",
                  operator: "EQUAL",
                  order: nextOrder,
                  techName: "",
                  value: [],
               };

               const updatedConditions = [...section.conditions, newCondition].sort(
                  (a, b) => a.order - b.order,
               );

               return {
                  ...section,
                  conditions: updatedConditions,
               };
            }
            return section;
         });

         return {
            ...prev,
            filterSections: updatedSections,
         };
      });
   };

   const moveContainer = (fromIndex: number, toIndex: number) => {
      const newData = filterFromList.filterSections.map((section) => ({
         ...section,
         conditions: [...section.conditions.map((c) => ({ ...c }))],
      }));

      const [movedSection] = newData.splice(fromIndex, 1);
      newData.splice(toIndex, 0, movedSection);

      newData.forEach((section, index) => {
         section.order = index;
      });

      setFilterFromList((prev) =>
         prev.id === currentFilter.id
            ? {
                 ...prev,
                 filterSections: newData,
              }
            : prev,
      );
   };

   const moveObject = (from, to) => {
      const newData = filterFromList.filterSections.map((section) => ({
         ...section,
         conditions: [...section.conditions.map((c) => ({ ...c }))],
      }));
      const fromList = newData[from.containerIndex].conditions;
      const toList = newData[to.containerIndex].conditions;

      const [movedObj] = fromList.splice(from.objectIndex, 1);
      toList.splice(to.objectIndex, 0, movedObj);

      fromList.forEach((obj, idx) => (obj.order = idx));
      if (from.containerIndex !== to.containerIndex) {
         toList.forEach((obj, idx) => (obj.order = idx));
      }

      setFilterFromList((prev) =>
         prev.id === currentFilter.id
            ? {
                 ...prev,
                 filterSections: newData,
              }
            : prev,
      );
   };

   const changeSectionJoinOperator = (order: number, value: { value: string }) => {
      setFilterFromList((prevFilter) => {
         if (prevFilter.id === currentFilter.id) {
            const updatedSections = prevFilter.filterSections.map((section) =>
               section.order === order ? { ...section, joinOperator: value.value } : section,
            );

            return {
               ...prevFilter,
               filterSections: updatedSections,
            };
         }
         return prevFilter;
      });
   };

   const changeFilterInfo = (field, value) => {
      setFilterFromList((prev) => ({ ...prev, [field]: value }));
   };

   const handleActiveChange = (sectionOrder: number, isActive: boolean) => {
      setFilterFromList((prevFilter) => ({
         ...prevFilter,
         filterSections: prevFilter.filterSections.map((section) =>
            section.order === sectionOrder ? { ...section, active: isActive } : section,
         ),
      }));
   };

   if (!currentFilter) return <Spin />;
   const allFilled = filterFromList?.filterSections?.every((container) =>
      container?.conditions?.every((obj) => obj.value && obj.value.length > 0 && !!obj.value[0]),
   );
   return (
      <div>
         <Modal
            isOpen={isOpen}
            width={1080}
            height={window.innerHeight / 1.05}
            bodyStyles={{ overflowX: "auto" }}
            topBarStyles={{
               justifyContent: "space-between",
               color: projectConfig.cssVariables["--topbar-text"],
               fontSize: "24px",
               fontWeight: "900",
               fontFamily: projectConfig.cssVariables["--font-primary"],
               padding: "20px",
            }}
            wrapClassName="no-resize"
            topBarContent={
               currentFilter?.name ? topBarTitle : <IntlMessages id={"modalEdit.add_filter"} />
            }
         >
            <div className="main-filter-editor-container">
               {activeTab === 1 && (
                  <>
                     <span className="filter-editor-header">Warunki</span>
                     <div className="filter-editor-columns-header">
                        {" "}
                        <Button
                           onClick={() => handleAddSection(currentFilter)}
                           style={{ width: "32px", height: "32px" }}
                           buttonType="primary"
                        >
                           <span className="material-symbols-outlined">add</span>
                        </Button>
                        <div className="header-labels">
                           <span className="condition">Warunek</span>
                           <span className="field">Pole</span>
                           <span className="equation">Równanie</span>
                           <span className="value">Wartość</span>
                        </div>
                     </div>
                  </>
               )}
               <div className="drag-and-drop-container">
                  {activeTab === 1 && (
                     <DndProvider backend={HTML5Backend}>
                        {filterFromList?.filterSections?.map((container, containerIndex) => (
                           <DraggableContainer
                              key={container?.order}
                              index={container?.order}
                              container={container}
                              moveContainer={moveContainer}
                              customClassName="draggable-container-styles"
                              renderContent={(connectDragSource) => (
                                 <>
                                    <Checkbox
                                       checked={container?.active}
                                       onChange={(e) =>
                                          handleActiveChange(container?.order, e.target.checked)
                                       }
                                    />
                                    {connectDragSource(
                                       <div className="drag-button">
                                          <span className="material-symbols-outlined">
                                             drag_indicator
                                          </span>
                                       </div>,
                                    )}
                                 </>
                              )}
                           >
                              {container?.conditions?.map((obj, objIndex) => (
                                 <DraggableObject
                                    key={objIndex}
                                    objectData={obj}
                                    objectIndex={objIndex}
                                    containerIndex={containerIndex}
                                    moveObject={moveObject}
                                    customClassName="draggable-item-styles"
                                    renderContent={(connectDragSource) => (
                                       <DraggableObjectContent
                                          connectDragSource={connectDragSource}
                                          object={obj}
                                          columnList={columnList}
                                          setFilterFromList={setFilterFromList}
                                          listFilters={listFilters}
                                          currentFilter={filterFromList}
                                          currentSection={container}
                                       />
                                    )}
                                 />
                              ))}
                              <div
                                 style={{ position: "absolute", right: "10px", bottom: "19px" }}
                                 className="list-filters-add-container"
                              >
                                 <Button
                                    onClick={() => handleAddCondition(container)}
                                    style={{ width: "25px", height: "25px", marginLeft: "10px" }}
                                    buttonType="primary"
                                    size="small"
                                 >
                                    <span
                                       style={{ fontSize: "23px" }}
                                       className="material-symbols-outlined"
                                    >
                                       add
                                    </span>
                                 </Button>
                              </div>
                              <div
                                 style={{
                                    position: "absolute",
                                    left: "7px",
                                    zIndex: "2",
                                    bottom: "-21px",
                                    width: "60px",
                                 }}
                              >
                                 <Switch
                                    checked={container?.joinOperator === "AND"}
                                    size="default"
                                    onChange={(e) =>
                                       changeSectionJoinOperator(container?.order, {
                                          value: e ? "AND" : "OR",
                                       })
                                    }
                                    label="AND"
                                    label2="OR"
                                    customLabelStyle={{
                                       color: "white",
                                       marginLeft: "7px",
                                       position: "relative",
                                    }}
                                    customLabel2Style={{ color: "white", marginLeft: "25px" }}
                                    customBackgroundColor="#FFB400"
                                 />
                              </div>
                           </DraggableContainer>
                        ))}
                     </DndProvider>
                  )}
                  <div style={{ paddingTop: "2rem" }}>
                     <span>Nazwa:</span>
                     <Input
                        value={filterFromList?.name}
                        onChange={(e) => changeFilterInfo("name", e.target.value)}
                     />
                  </div>
                  <div style={{ paddingTop: "1rem" }}>
                     <span>Opis:</span>
                     <TextArea
                        value={filterFromList?.description}
                        onChange={(e) => changeFilterInfo("description", e.target.value)}
                     />
                  </div>
                  <div className="confirm-modal__actions">
                     <Button
                        className="confirm-modal__button confirm-modal__button--cancel"
                        onClick={() => {
                           setCurrentFilter(undefined);
                           setIsOpen(false);
                        }}
                     >
                        <IntlMessages id="global.cancel" />
                     </Button>
                     <Button
                        className="confirm-modal__button confirm-modal__button--confirm"
                        onClick={() => {
                           handleSaveFilter(filterFromList);
                           setIsOpen(false);
                        }}
                        disabled={
                           activeTab === 1
                              ? !filterFromList?.name ||
                                !filterFromList?.filterSections.length ||
                                !allFilled
                              : !filterFromList?.name
                        }
                     >
                        <IntlMessages id="global.save" />
                     </Button>
                  </div>
               </div>
            </div>
         </Modal>
      </div>
   );
};

export default TableFilterEditor;
